import { CardHeader } from "../../parts/CardHeader"

type Props = {
  title: string
  description?: string
  /** @dehub/help `section` key: section «?» after the heading (R2). */
  helpKey?: string
}

// Section heading: the same title + «?» with the meta line under it as the
// overview cards and the overview «Буцаалтын тойм» section (parts/CardHeader).
export function SectionHeader({ title, description, helpKey }: Props) {
  return <CardHeader title={title} subtitle={description} helpKey={helpKey} />
}
